import { useContext, useCallback } from 'react';
import FormContext from '../../Form/FormContext.js';

function useFormValueChanged(formFieldName, onChangeValue) {
    const formContext = useContext(FormContext);
    return useCallback(((value, validation, isOnInitialization) => {
        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(value, validation, isOnInitialization);
        formContext === null || formContext === void 0 ? void 0 : formContext.valueChanged(formFieldName, value, validation, isOnInitialization);
    }), [formContext, formFieldName, onChangeValue]);
}

export { useFormValueChanged as default };
